// extracted by mini-css-extract-plugin
export var body = "d_R";
export var description = "d_L";
export var figure = "d_S";
export var getStarted = "d_V";
export var screenshot = "d_T";
export var toolLinks = "d_W";